import { render, staticRenderFns } from "./SpacerEditor.vue?vue&type=template&id=912fc73e&"
import script from "./SpacerEditor.vue?vue&type=script&lang=js&"
export * from "./SpacerEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports